module.exports = __webpack_public_path__ + "static/img/graphic-boat.752c69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphic-boat.jpg
// module id = 194
// module chunks = 0